export default __webpack_public_path__ + "static/6_31-d4fc7839a588a4f83658c4043317b0de.png";